import { IComponent } from '../types';
import { isComponent } from './typeGuards';
import { uuidv4 } from './uuid';

export function isComponentOfType<T extends Partial<IComponent> = Partial<IComponent>>(item: unknown, ...blockTypes: string[]): item is T {
  return isComponent(item) && blockTypes.includes(item.blockType || item.schema || '');
}

export function pickComponent(items: IComponent[] | undefined, ...blockTypes: string[]): IComponent[] | undefined {
  return items?.filter(x => isComponentOfType(x, ...blockTypes));
}

export function excludeComponent(items: IComponent[] | undefined, ...blockTypes: string[]): IComponent[] | undefined {
  return items?.filter(x => !isComponentOfType(x, ...blockTypes));
}

export function pickHero(items: IComponent[] | undefined, blockTypes: string[] = ['hero']): [IComponent[] | undefined, IComponent[] | undefined] {
  const heroComponents = pickComponent(items, ...blockTypes);
  const otherComponents = excludeComponent(items, ...blockTypes);
  return [heroComponents, otherComponents];
}

export function prependHero(items: IComponent[] | undefined, hero: IComponent | string, blockType: string = 'hero'): IComponent[] {
  const components = items || [];
  const heroIndex = components.findIndex(x => isComponentOfType(x, blockType));
  if (heroIndex === -1) {
    const component: IComponent = typeof hero === 'string' ? {
      id: uuidv4(),
      blockType: hero,
    } : hero;
    components.unshift(component);
  }
  return components;
}

export function groupComponents(items: IComponent[] | undefined, blockTypes: string[], blockType: string): IComponent[] {
  const components: IComponent[] = [];
  let previousGroup: IComponent & { components: IComponent[] } | undefined;
  let previousItem: IComponent | undefined;
  (items || []).forEach((item) => {
    if (blockTypes.includes(item.blockType || item.schema || 'unkown_type')) {
      if (previousItem) {
        if (previousGroup) {
          previousGroup.components.push(item);
        } else {
          previousGroup = {
            id: uuidv4(),
            blockType,
            components: [previousItem, item],
          };
        }
      }
      previousItem = item;
    } else {
      if (previousGroup) {
        components.push(previousGroup);
      } else if (previousItem) {
        components.push(previousItem);
      }
      previousGroup = undefined;
      previousItem = undefined;
      components.push(item);
    }
  });
  return components;
}
